// @ts-nocheck
import { createStore } from 'solid-js/store';
// import { template, insert } from 'solid-js/web';
import { createI18n as create } from 'i18n-mini';
import type { I18nOptions } from 'i18n-mini';
import type { I18n } from './types';

export { defineMessages } from 'i18n-mini';
export type { I18nPresets } from 'i18n-mini';

export { I18nProvider } from './components/I18nProvider';
export { Text } from './components/Text';
export { Numeric } from './components/Numeric';
export { DateTime } from './components/DateTime';
export { useI18n } from './context';

export type { TextProps } from './components/Text';
export type { NumericProps } from './components/Numeric';
export type { DateTimeProps } from './components/DateTime';
export type { I18n } from './types';

function formatTag(tag: string, child: string | string[] | undefined) {
//  const el = template(`<${tag}>`, 0);
//  insert(el, () => child);
//  return el;
  return child;
}

function cloneFunc(func: () => void) {
  return func.bind({});
}

function cloneI18n(i18n: Readonly<I18n>): Readonly<I18n> {
  return {
    ...i18n,
    t: cloneFunc(i18n.t),
    formatNumber: cloneFunc(i18n.formatNumber),
    formatDateTime: cloneFunc(i18n.formatDateTime),
  };
}

export function createI18n(options: Omit<I18nOptions, 'formatTag'>): Readonly<I18n> {
  const { i18n, subscribe } = create({ ...options, formatTag });

  const [store, setStore] = createStore(cloneI18n(i18n));
  subscribe(() => setStore(cloneI18n(i18n)));

  return store;
}


const FRENCH_SIZES = ["octets", "ko", "Mo", "Go"];
const ENGLISH_SIZES = ["bytes", "kB", "MB", "GB"];
/**
 * Format bytes to human readable string
 */
export function formatBytes(bytes: number, locale?: string): string {
  const fr = locale?.startsWith("fr");
  let sizes;
  if (fr) {
    sizes = FRENCH_SIZES;
  } else {
    sizes = ENGLISH_SIZES;
  }
  if (bytes === 0) return `0 ${sizes[0]}`;
  const k = 1000;

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

/**
 * A duration in seconds as "3 min 07 s" — or "45 s" under a minute. The units
 * read the same in both languages, so there is nothing to translate.
 */
export function formatSeconds(seconds: number): string {
  const whole = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(whole / 60);
  return minutes > 0 ? `${minutes} min ${String(whole % 60).padStart(2, "0")} s` : `${whole} s`;
}

/** How long between two timestamps, formatted like formatSeconds. */
export function formatDuration(from: string, to: string): string {
  return formatSeconds((new Date(to).getTime() - new Date(from).getTime()) / 1000);
}